import * as tslib_1 from "tslib";
import { SearchesCommon } from '../searches.common';
import { TrDetailComponent } from '../components/searches-detail/tr-detail/tr-detail.component';
var SearchesTrComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchesTrComponent, _super);
    function SearchesTrComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayedColumns = ['checkbox', 'matchedTerm', 'categories', 'countryLinks', 'matchStrength', 'options', 'matched'];
        return _this;
    }
    SearchesTrComponent.prototype.selectDetail = function (item) {
        this.dialogRef = this.dialog.open(TrDetailComponent, { data: item, autoFocus: false, width: '1300px' });
    };
    return SearchesTrComponent;
}(SearchesCommon));
export { SearchesTrComponent };
